"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.camelize = camelize;
exports.snakify = snakify;

var _camelCase = _interopRequireDefault(require("lodash/camelCase"));

var _snakeCase = _interopRequireDefault(require("lodash/snakeCase"));

var _functools = require("@edison/functools");

/**
 * Helper method that converts from snake case to camel case.
 *
 * This is needed because Python deals with variables in snake case while
 * frontend deals in camel case.
 */
function camelize(o, exclude) {
  // Taken from https://stackoverflow.com/questions/2970525/converting-any-string-into-camel-case
  var toCamelCase = function toCamelCase(s) {
    return (0, _camelCase["default"])(s);
  };

  return (0, _functools.mapKeys)(toCamelCase)(o);
}
/**
 * Helper method that converts from camel case to snake case.
 */


function snakify(o, exclude) {
  var toSnakeCase = function toSnakeCase(s) {
    return (0, _snakeCase["default"])(s);
  };

  return (0, _functools.mapKeys)(toSnakeCase)(o);
}
//# sourceMappingURL=format.js.map